import { render, staticRenderFns } from "./sellerorder.vue?vue&type=template&id=0da8c300&scoped=true&"
import script from "./sellerorder.vue?vue&type=script&lang=js&"
export * from "./sellerorder.vue?vue&type=script&lang=js&"
import style0 from "./sellerorder.vue?vue&type=style&index=0&id=0da8c300&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da8c300",
  null
  
)

export default component.exports